module.exports = __webpack_public_path__ + "media/app/assets/soulbinds/conduit-d655b2f1a082bf55bfc95092c2ff7456.png";